import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ADMIN_MODULES_FLAT } from '../../constants/adminModules';
import { FiUsers, FiCheck } from 'react-icons/fi';

const StaffPage = () => {
  const { user } = useAuth();
  const modules = Array.isArray(user?.allowedModules) ? user.allowedModules : [];
  const moduleLabels = modules.map((path) => ADMIN_MODULES_FLAT.find((m) => m.path === path)?.label || path);

  return (
    <div className="min-h-screen bg-slate-50/60">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
          <div>
            <h1 className="text-xl font-semibold text-slate-900 tracking-tight">Staff</h1>
            <p className="text-sm text-slate-500 mt-0.5">
              {user?.role === 'staff' ? 'Your assigned modules and access.' : 'Staff users and access.'}
            </p>
          </div>
        </div>

        <div className="rounded-lg border border-slate-200 bg-white shadow-sm overflow-hidden">
          <div className="p-6">
            {user?.role === 'staff' ? (
              <>
                <h2 className="text-sm font-medium text-slate-800 mb-3 pb-2 border-b border-slate-100">Your assigned modules</h2>
                <p className="text-sm text-slate-600 mb-4">
                  You can access only the following areas in the admin sidebar. Contact an administrator to change your access.
                </p>
                {moduleLabels.length > 0 ? (
                  <ul className="space-y-2">
                    {moduleLabels.map((label, i) => (
                      <li key={i} className="flex items-center gap-2 text-sm text-slate-700">
                        <FiCheck className="h-4 w-4 text-emerald-600 shrink-0" />
                        {label}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-sm text-slate-500">No modules assigned yet.</p>
                )}
              </>
            ) : (
              <div className="flex items-center gap-3 text-slate-600">
                <FiUsers className="h-10 w-10 text-slate-300" />
                <p className="text-sm">This area is for staff users. Staff see their assigned modules here.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffPage;
